<template>
  <!-- XOL-586 (Delta 4): the header of the read-only information dialogs (the e-mail batch, the
       field / recipient changes, the Re-send picker): a round icon, the title, an optional
       status tag, and a subtitle under them. It goes in the el-dialog's `title` slot; keep
       `:title` on the dialog too (Element 2.15 uses it as the dialog's accessible name).
       Presentational: no store, no requests. `focus()` is where the dialog puts focus on open. -->
  <div class="info-header" :class="{ 'is-compact': compact }" tabindex="-1" ref="root">
    <span class="info-header__icon" aria-hidden="true"><i class="fa" :class="icon"></i></span>

    <div class="info-header__text">
      <div class="info-header__row">
        <span class="info-header__title">{{title}}</span>
        <el-tag v-if="tag" class="info-header__tag" size="small" effect="light" :type="tag.type">
          <i v-if="tag.icon" class="fa" :class="tag.icon" aria-hidden="true"></i><span>{{tag.text}}</span>
        </el-tag>
      </div>
      <div v-if="subtitle" class="info-header__subtitle" :title="subtitleTitle || null">{{subtitle}}</div>
    </div>

    <span v-if="srText" class="visually-hidden">{{srText}}</span>
  </div>
</template>

<script>
export default {
  name: 'info-dialog-header',

  props: {
    // An icon class: 'fa-envelope'.
    icon: {
      type: String,
      default: 'fa-info-circle'
    },

    title: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: null
    },

    // The full text for the subtitle's `title` attribute (when the subtitle is a shortened name).
    subtitleTitle: {
      type: String,
      default: null
    },

    // { text, type, icon } or null.
    tag: {
      type: Object,
      default: null
    },

    // Read out by a screen reader only (the sentence the header stands for).
    srText: {
      type: String,
      default: null
    },

    // Phone sizes: a 28px icon and a 16px title.
    compact: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    focus () {
      var el = this.$refs.root

      if (el && typeof el.focus === 'function') {
        el.focus()
      }
    }
  }
}
</script>

<style scoped>
.info-header { display: flex; align-items: center; gap: 12px; outline: none; padding-right: 28px; }
.info-header__icon { flex: none; display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: #F4F4F5; color: #909399; font-size: 16px; }
.info-header__text { min-width: 0; flex: 1; }
.info-header__row { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 10px; }
.info-header__title { font-size: 18px; line-height: 24px; color: #303133; }
.info-header__tag .fa { margin-right: 5px; }
.info-header__subtitle { margin-top: 2px; font-size: 13px; line-height: 20px; color: #606266; overflow-wrap: anywhere; }

.info-header.is-compact { gap: 10px; }
.info-header.is-compact .info-header__icon { width: 28px; height: 28px; font-size: 13px; }
.info-header.is-compact .info-header__title { font-size: 16px; line-height: 22px; }

.visually-hidden { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }
</style>

<style>
/* The shell of the information dialogs (Delta 4). Not scoped: these are Element's own elements.
   One place for all three dialogs: add `xol-info-dialog` to a dialog's custom-class. */
.xol-info-dialog .el-dialog__header { padding: 16px 20px 14px; border-bottom: 1px solid #EBEEF5; }
.xol-info-dialog .el-dialog__headerbtn { top: 18px; right: 18px; }
.xol-info-dialog .el-dialog__body { padding: 16px 20px; word-break: normal; overflow-wrap: break-word; max-height: 70vh; overflow-y: auto; }
.xol-info-dialog .el-dialog__footer { padding: 12px 20px; border-top: 1px solid #EBEEF5; }
</style>
